var _path, _rect, _rect2, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResidentPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53872 14H16.4613C18.1591 14 19 13.1557 19 11.4672V2.54098C19 0.852459 18.1591 0 16.4613 0H2.53872C0.848936 0 0 0.852459 0 2.54098V11.4672C0 13.1557 0.848936 14 2.53872 14ZM1.3017 2.61475C1.3017 1.76229 1.74638 1.31967 2.55489 1.31967H16.4451C17.2374 1.31967 17.6983 1.76229 17.6983 2.61475V3H9.5H1.3017V2.61475ZM2.55489 12.6803C1.74638 12.6803 1.3017 12.2459 1.3017 11.3934V3H9.5H17.6983V11.3934C17.6983 12.2459 17.2374 12.6803 16.4451 12.6803H2.55489Z",
    fill: "#14142B"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 3,
    width: 3,
    height: 2,
    rx: 1,
    fill: "#14142B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 6,
    height: 2,
    rx: 1,
    fill: "#14142B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 4.5,
    r: 2,
    stroke: "#14142B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.5C6.23768 11.5 6.92855 11.3813 7.45346 11.1713C7.71453 11.0669 7.95936 10.9301 8.14709 10.7525C8.33588 10.574 8.5 10.3199 8.5 10C8.5 9.68015 8.33588 9.42602 8.14709 9.24748C7.95936 9.06993 7.71453 8.93308 7.45346 8.82865C6.92855 8.61869 6.23768 8.5 5.5 8.5C4.76232 8.5 4.07145 8.61869 3.54654 8.82865C3.28547 8.93308 3.04064 9.06993 2.85291 9.24748C2.66412 9.42602 2.5 9.68015 2.5 10C2.5 10.3199 2.66412 10.574 2.85291 10.7525C3.04064 10.9301 3.28547 11.0669 3.54654 11.1713C4.07145 11.3813 4.76232 11.5 5.5 11.5Z",
    stroke: "#14142B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentPortal);
export default __webpack_public_path__ + "static/media/ResidentPortal.aa61f4da5641ed343b3e60bc7814163d.svg";
export { ForwardRef as ReactComponent };